import React from 'react';
import PropTypes from 'prop-types';

const UploadPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M18.5 25l.001-4.999h2.011a.46.46 0 0 0 .378-.197c.167-.22.145-.533-.075-.7l-4.011-5.002a.5.5 0 0 0-.605 0l-4.012 5.002a.491.491 0 0 0-.187.398c0 .275.214.5.49.5H14.5L14.5 25H8v-.022a5.5 5.5 0 0 1 .13-10.966 8.502 8.502 0 0 1 16.138-1.967A6.501 6.501 0 0 1 24 24.98V25h-5.5zm-.5 0h-3 3z"
    />
  );
};

UploadPath.propTypes = {
  fill: PropTypes.string,
};

export default UploadPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/upload.jsx